<template>
  <div class="NumbersAboutMe">
      <div id="numbersAboutMe" class="flex flex-col bg-gradient mt-32 py-10 items-center text-center text-white">
      <!-- <span class="w-full text-4xl font-bold text-mytext-primary">{{ $t('numbersAboutMe.title') }}</span> -->
     <!--  <span class="w-full md:max-w-xl px-10 text-sm text-center ">{{ $t('numbersAboutMe.details') }}</span> -->
      <div class="w-full flex flex-wrap px-10 mt-5">
        <div class="w-full md:w-1/3 mt-10 px-5" :class="index > 2 ? '':'md:mt-0'" v-for="(item,index) in box" :key="index">
            <div class="wow pulse" data-wow-delay=".3s" data-wow-duration="1.5s">
                <div class="flex flex-col text-center">
                    <div class="flex justify-center ">
                        <img class="w-12 h-12" :src="item.imgPath" alt="musab" title="musab">
                    </div>
                    <ICountUp @ready="onReady" :delay="1000" :endVal="item.number" :options="{useEasing: true,useGrouping: true,suffix: '+'}" class="counter font-mono" style="font-size:75px; "/>
                    <h5 class="tracking-widest" v-text="item.details" />
                </div>
            </div>
        </div>

      </div>
      
    </div>
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2';

export default {
  name: 'NumbersAboutMe',
  components: {
    ICountUp
  },
  data() {
    return {
      instances:[],
      instanceBool:true,
      box:[
            {
                id:1,
                imgPath:require("@/assets/img/user-2-fill.svg"),
                number:30,
                details:this.$i18n.t('numbersAboutMe.box.1.details')
            },
            {
                id:2,
                imgPath:require("@/assets/img/team-fill.svg"),
                number:5,
                details:this.$i18n.t('numbersAboutMe.box.2.details')
            },
            {
                id:3,
                imgPath:require("@/assets/img/code-slash.svg"),
                number:3,
                details:this.$i18n.t('numbersAboutMe.box.3.details')
            }
        ]
    }
  },
  created() {
    var vm=this;
    window.onscroll = function() {
      const el = document.querySelector('.counter');
      // set scroll position in px
      if (vm.instanceBool && vm.between(el.getBoundingClientRect().top, -100, 400)) {
        vm.instances.length != 0 ? vm.instanceBool = false:'';
        vm.instances.forEach(instance => {
          instance.reset();
          instance.start();

        });
      }
    };
  },
  methods: {
    between(x, min, max) {
      return x >= min && x <= max;
    },
    onReady: function(instance) {
      var vm=this;
      vm.instances.push(instance)
    }
  },
  computed: {
    langLocaleNow(){
      return this.$i18n.locale
    }
  },
  watch: {
    langLocaleNow(){
      Object.assign(this.$data,this.$options.data.call(this))
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>